export const EMAIL_VERIFICATION_ERROR = 'email-verification-error';

export const CONTINUE_ERROR_SHOWN = 'continue-error-shown';
export const ERROR_MESSAGE_SHOWN = 'error-message-shown';
export const FORM_VALIDATION_ERROR = 'form_validation_error_displayed';
export const RECURRING_ERROR_SHOWN = 'error-message-recurring-shown';

export const CONNECTION_BUSINESS_ADDRESS_ERROR = 'BUSINESS_ADDRESS_ERROR';
export const CONNECTION_SAVE_DRAFT_ERROR = 'SAVE_DRAFT_ERROR';
export const CONNECTION_SESSION_EXPIRED_ERROR = 'SESSION_EXPIRED_ERROR';
export const CONNECTION_ERROR = 'CONNECTION_ERROR';

export const ON_CREDIT_HOLD_ERROR = 'ON_CREDIT_HOLD_ERROR';

export const PAGE_VALIDATION_ERROR = 'PAGE_VALIDATION_ERROR';

export const EDIT_PAGE_CONNECTION_SAVE_DRAFT_ERROR =
  'EDIT_PAGE_CONNECTION_SAVE_DRAFT_ERROR';
export const EDIT_PAGE_CONNECTION_JOB_EDIT_ERROR =
  'EDIT_PAGE_CONNECTION_JOB_EDIT_ERROR';
export const EDIT_PAGE_CONNECTION_JOB_EDIT_NO_REVISION_ID_ERROR =
  'EDIT_PAGE_CONNECTION_JOB_EDIT_NO_REVISION_ID_ERROR';
export const EDIT_PAGE_CONNECTION_ORDER_CREATE_NO_JOB_ID =
  'EDIT_PAGE_CONNECTION_ORDER_CREATE_NO_JOB_ID';
export const EDIT_PAGE_CONNECTION_ORDER_CREATE_GENERIC_ERROR =
  'EDIT_PAGE_CONNECTION_ORDER_CREATE_GENERIC_ERROR';
export const EDIT_PAGE_CONNECTION_ORDER_CREATE_NO_ORDER_ID_ERROR =
  'EDIT_PAGE_CONNECTION_ORDER_CREATE_NO_ORDER_ID_ERROR';
export const EDIT_PAGE_CONNECTION_CONFIRM_INVOICE_GENERIC_ERROR =
  'EDIT_PAGE_CONNECTION_CONFIRM_INVOICE_GENERIC_ERROR';
export const EDIT_PAGE_CONNECTION_CONFIRM_INVOICE_INVOICE_ORDER_NOT_FOUND_ERROR =
  'EDIT_PAGE_CONNECTION_CONFIRM_INVOICE_INVOICE_ORDER_NOT_FOUND_ERROR';
export const EDIT_PAGE_CONNECTION_CONFIRM_INVOICE_ORDER_ERROR =
  'EDIT_PAGE_CONNECTION_CONFIRM_INVOICE_ORDER_ERROR';
export const EDIT_PAGE_CONNECTION_CONFIRM_INVOICE_ORDER_EXPIRED_ERROR =
  'EDIT_PAGE_CONNECTION_CONFIRM_INVOICE_ORDER_EXPIRED_ERROR';
